<template>
  <controller :lockScroll="lockScroll">
    <list-controller></list-controller>
  </controller>
</template>

<script>
import ListController from '@/components/ferramentas/onlineUsers/List.vue'

export default {
  components: {
    ListController
  },
  data() {
    return {
      categoria: null
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>

<style>

</style>
